var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b',{class:{'white--text': _vm.$vuetify.theme.dark}},[_c('span',{staticClass:"primary--text"},[_vm._v("on")]),_vm._v("COGITE")])}
var staticRenderFns = []

export { render, staticRenderFns }